<template>
  <div id="monitoramento">
    <div class="row">
      <div class="col-md-12">
        <vuestic-widget headerText="Monitoramento das Aulas Teóricas">
          <div class="text-center">
            <h1 id="clock"></h1>
          </div>
          <div class="row">
            <div class="col-md-12 text-center">
              <div class="row" style="justify-content: space-evenly">
                <template v-for="(sala, i) in salasFiltradas">
                  <div class="card" :key="sala.id" v-if="sala.aula.fotos.length > 0">
                    <img
                      v-if="sala.aula.fotos[sala.aula.fotos.length - 1].id_status === 1"
                      @click="paginaSala(sala)"
                      class="img-monit"
                      :src="'data:image/' + sala.aula.fotos[sala.aula.fotos.length - 1].ext +';base64, ' + sala.aula.fotos[sala.aula.fotos.length - 1].foto"
                      alt="Imagem 1"
                      :id="sala.id + '_' + sala.aula.fotos[sala.aula.fotos.length - 1].id_foto_teorica"
                      style="border: solid 5px rgb(255, 0, 0)"
                    />

                    <img
                      v-else-if="sala.aula.fotos[sala.aula.fotos.length - 1].id_status === 2"
                      @click="paginaSala(sala)"
                      class="img-monit"
                      :src="'data:image/' + sala.aula.fotos[sala.aula.fotos.length - 1].ext +';base64, ' + sala.aula.fotos[sala.aula.fotos.length - 1].foto"
                      alt="Imagem 1"
                      :id="sala.id + '_' + sala.aula.fotos[sala.aula.fotos.length - 1].id_foto_teorica"
                      style="border: solid 5px rgb(255, 0, 0)"
                    />

                    <img
                      v-else-if="sala.aula.fotos[sala.aula.fotos.length - 1].id_status === 3"
                      @click="paginaSala(sala)"
                      class="img-monit"
                      :src="'data:image/' + sala.aula.fotos[sala.aula.fotos.length - 1].ext +';base64, ' + sala.aula.fotos[sala.aula.fotos.length - 1].foto"
                      alt="Imagem 1"
                      :id="sala.id + '_' + sala.aula.fotos[sala.aula.fotos.length - 1].id_foto_teorica"
                      style="border: solid 5px rgb(255, 251, 0)"
                    />

                    <img
                      v-else-if="sala.aula.fotos[sala.aula.fotos.length - 1].id_status === 4"
                      @click="paginaSala(sala)"
                      class="img-monit"
                      :src="'data:image/' + sala.aula.fotos[sala.aula.fotos.length - 1].ext +';base64, ' + sala.aula.fotos[sala.aula.fotos.length - 1].foto"
                      alt="Imagem 1"
                      :id="sala.id + '_' + sala.aula.fotos[sala.aula.fotos.length - 1].id_foto_teorica"
                      style="border: solid 5px rgb(9, 255, 0)"
                    />

                    <img
                      v-else
                      @click="paginaSala(sala)"
                      class="img-monit"
                      :src="'data:image/' + sala.aula.fotos[sala.aula.fotos.length - 1].ext +';base64, ' + sala.aula.fotos[sala.aula.fotos.length - 1].foto"
                      alt="Imagem 1"
                      :id="sala.id + '_' + sala.aula.fotos[sala.aula.fotos.length - 1].id_foto_teorica"
                    />

                    <!-- <img class="img-monit" src="http://176.180.45.18:8082/mjpg/video.mjpg" alt=""> -->

                    <div class="container">
                      <h2>
                        <b>{{ sala.sala }}</b>
                      </h2>
                      <div class="row" style="justify-content: center;">
                        <table class="table-responsive-sm">
                          <tr>
                            <td>CFC:</td>
                            <td>{{ sala.cfc }}</td>
                          </tr>
                          <tr>
                            <td>Turma:</td>
                            <td>{{ sala.aula.turma.titulo }}</td>
                          </tr>
                          <tr>
                            <td>Aula:</td>
                            <td>{{ sala.aula.id_aula_teorica }}</td>
                          </tr>
                          <tr>
                            <td>Instrutor:</td>
                            <td>{{ sala.aula.instrutor.nome }}</td>
                          </tr>
                          <tr>
                            <td>Materia:</td>
                            <td>{{ sala.aula.materia.titulo }}</td>
                          </tr>
                          <tr>
                            <td>Aula iniciada as:</td>
                            <td>{{ sala.aula.inicio.split(' ')[1] }}</td>
                          </tr>
                          <tr>
                            <td>Fim previsto:</td>
                            <td>{{ sala.aula.fim.split(' ')[1] }}</td>
                          </tr>
                          <tr>
                            <td>Quantidade de alunos na turma:</td>
                            <td>{{ sala.aula.turma.quantidade_alunos }}</td>
                          </tr>
                          <tr>
                            <td>Presenças confirmadas:</td>
                            <td>{{ sala.aula.quantidade_alunos_presentes }}</td>
                          </tr>
                          <tr>
                            <td>Pessoas detectadas:</td>
                            <td>{{ sala.aula.fotos[sala.aula.fotos.length - 1].faces.length }}</td>
                          </tr>
                        </table>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-md-12">
                          <button
                            title="Nenhum aluno detectado"
                            class="btn btn-danger btn-with-icon rounded-icon size"
                            @click="imageStatus(i,1)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-user-times"
                              style="font-size: 16px;padding-left: 6px;"
                            ></span>
                          </button>
                          &nbsp;
                          <button
                            title="Sem imagem"
                            class="btn btn-danger btn-with-icon rounded-icon size"
                            @click="imageStatus(i, 2)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-low-vision"
                              style="font-size: 16px;padding-left: 2px;"
                            ></span>
                          </button>
                          &nbsp;
                          <button
                            title="Imagem com erro"
                            class="btn btn-warning btn-with-icon rounded-icon size"
                            @click="imageStatus(i, 3)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-exclamation-triangle"
                              style="font-size: 16px;padding-left: 3px;"
                            ></span>
                          </button>
                          &nbsp;
                          <button
                            title="Imagem OK"
                            class="btn btn-success btn-with-icon rounded-icon size"
                            @click="imageStatus(i, 4)"
                          >
                            <span
                              aria-hidden="true"
                              class="fa fa-check"
                              style="font-size: 16px;padding-left: 3px;"
                            ></span>
                          </button>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>

<script>
import MonitoramentoController from "./MonitoramentoController";

export default {
  data() {
    return {
      salas: [],
      imageCheck: false,
      aulas: [],
      salaModal: [],
      salaModalCheck: false,
      imageModal: "image-check",
      count_faces: 0,
      pessoaModal: "",
    };
  },
  mounted() {
    let self = this;
    MonitoramentoController.startTime();

    MonitoramentoController.getSalas(function (data) {
      data.dados.map(function (value) {
        self.salas.push({
          id: value.id_sala,
          sala: value.sala,
          cfc: value.cfc,
          aula: [],
        });
      });
      console.log("sala");
      console.log(self.salas);

      self.showAula();
    });
  },
  computed: {
    salasFiltradas: function () {
      return this.salas.filter(function (sala) {
        if (sala.aula.length !== 0) {
          return sala;
        }
      });
    },
  },
  methods: {
    imageStatus(key, type) {
      let self = this;

      let idAula = this.salas[key].aula.id_aula_teorica;

      MonitoramentoController.updateFotoTodas(idAula, type);

      this.salas[key].aula.fotos.forEach((foto => {
        foto.id_status = type;
      }))

    },

    paginaSala(idSala) {
      let self = this;
      self.salaModal = idSala;
      self.salaModalCheck = true;
      self.$refs.smallModal.open();
    },

    checkImage(key) {
      let self = this;

      var idFoto = key.split("_")[0];
      self.imageModal = key.split("_")[3] + "_" + idFoto;

      for (var key_foto in self.salas[self.salaModal].aula.fotos) {
        if (self.salas[self.salaModal].aula.fotos.hasOwnProperty(key_foto)) {
          if (
            self.salas[self.salaModal].aula.fotos[key_foto].id_foto_teorica ==
            idFoto
          ) {
            var foto = self.salas[self.salaModal].aula.fotos[key_foto];
            self.count_faces = key_foto;

            if (foto.pessoa) {
              self.pessoaModal = foto.pessoa;
              self.pessoaModal.entidade = foto.entidade;
            }
          }
        }
      }

      var imageThumb = document.getElementById(key);
      var image = document.getElementById(self.imageModal);

      image.src = imageThumb.src;
      image.style.border = imageThumb.style.border;

      var canvas = document.getElementById("canvas");
      canvas.style.border = imageThumb.style.border;

      var ctx = canvas.getContext("2d");

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      let widthDiff = canvas.width / image.naturalWidth;
      let heightDiff = canvas.height / image.naturalHeight;

      // ctx.drawImage(image, 0, 0, image.width * 2.65, image.height * 2.65);
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      ctx.strokeStyle = "#0804DF";
      ctx.lineWidth = 5;

      foto.faces.forEach(function (face) {
        if (face.width < 150) {
          ctx.beginPath();
          ctx.moveTo(face.x * widthDiff, face.y * heightDiff);
          ctx.lineTo(face.x * widthDiff, (face.y + face.height) * heightDiff);
          ctx.lineTo(
            (face.x + face.width) * widthDiff,
            (face.y + face.height) * heightDiff
          );
          ctx.lineTo((face.x + face.width) * widthDiff, face.y * heightDiff);
          ctx.lineTo(face.x * widthDiff, face.y * heightDiff);
          ctx.stroke();
          ctx.closePath();
        }
      });
      self.imageCheck = true;
    },

    showAula() {
      let self = this;

      self.salas.forEach((sala, index) => {
        MonitoramentoController.getAula(function (aula) {
          if (aula != null) {
            self.salas[index].aula = aula;
          }
        }, sala);
      });

      setTimeout(function () {
        self.showAula(self.salas);
      }, 60000);
    },
    paginaSala(sala) {
      MonitoramentoController.paginaSalaTeorica(sala);
    },
  },
};
</script>

<style scoped>
/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgb(24, 255, 3);
}

/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 10px; /* 5px rounded corners */
  margin: 5px;
}

/* Add rounded corners to the top left and the top right corner of the image */
.img-monit {
  width: 450px;
  border-radius: 10px 10px 0 0;
}

.img-monit-modal {
  width: 500px;
  height: 500px;
  border-radius: 10px;
}

.img-thumb {
  width: 200px;
  height: 200px;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

#clock {
  font-family: "Share Tech Mono", monospace;
  color: #080808;
  text-align: center;
}

.size {
  width: 4rem;
  height: 4rem;
}

tr {
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

table {
  width: 100%;
}
</style>
